import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ConfirmationDialog = ({ open, onClose, onConfirm }) => {
    return (
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            padding: 0,
            minHeight: 'fit-content',
            maxHeight: 'fit-content'
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 16px',
            backgroundColor: '#102A62',
            margin: 0,
            width: '100%',
            height: '50px',
            boxSizing: 'border-box',
            textAlign: 'center'
          }}
        >
          <Typography
            sx={{
              color: '#FFFFFF',
              fontFamily: 'Montserrat',
              fontWeight: 600,
              fontSize: '20px',
              textAlign: 'center'
            }}
          >
            Confirmation
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            padding: '20px',
            overflow: 'hidden',
            marginTop: '20px',
          }}
        >
          <Typography
            sx={{
              color: '#000000DE',
              fontFamily: 'Montserrat',
              fontSize: '16px',
              lineHeight: '24px',
              marginBottom: '20px'
            }}
          >
            Are you sure, Do you want to proceed?
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '0 20px 20px 20px',
            justifyContent: 'center',
            gap: 6
          }}
        >
          <Button
            onClick={() => onClose(false)}
            variant="outlined"
            sx={{
              color: 'white',
              borderColor: '#62636C',
              background: '#62636C',
              textTransform: 'none',
              fontFamily: 'Montserrat',
              '&:hover': {
                color: 'white',
                background: '#62636C',
              }
            }}
          >
            No
          </Button>
          <Button
            onClick={() => onConfirm(true)}
            variant="contained"
            sx={{
              backgroundColor: '#004F9F',
              color: 'white',
              textTransform: 'none',
              fontFamily: 'Montserrat',
              '&:hover': {
                backgroundColor: '#004F9F'
              }
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };


export default ConfirmationDialog;